export default function speak({ current: input }, { current: submitBtn }) {
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();
  // После того как слово принято прекращаем прослушивание
  recognition.continuous = false;
  // Указываем язык
  //   recognition.lang = 'en-US';
  // разрешаем/запрещаем выводить промежуточный результат
  recognition.interimResults = false;
  // Указываем число вариантов что мог "услышать" микрофон
  recognition.maxAlternatives = 1;
  recognition.onerror = (event) => {
    // info.textContent = (`Error occurred in recognition: ${event.error}`);
    console.log(event.error);
  };

  recognition.onresult = (event) => {
    const last = event.results.length - 1;
    const sayWord = event.results[last][0].transcript;
    input.value = sayWord;
    submitBtn.click();
  };
  return recognition;
}
